import React from 'react'
import "./BeautyGarage.css"
const BeautyGarageHead = () => {
  return (
    <div className='beautyGarageHeadContainer'>
      <h2>Beauty Garage</h2>
      <div className="beautyGarageUnderline"></div>
    </div>
  )
}

export default BeautyGarageHead
